import {
  GetCrowdinProjectFilesRequest,
  GetCrowdinProjectFilesResponse,
  GetCrowdinProjectLanguagesRequest,
  GetCrowdinProjectLanguagesResponse,
  UploadCrowdinTranslationsToTemplateRequest,
  UploadCrowdinTranslationsToTemplateResponse,
  UploadTemplateStringsToCrowdinRequest,
  UploadTemplateStringsToCrowdinResponse,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/translations_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";

export const getCrowdinProjectFiles = async (
  headers: Record<RequestMetadata, string>
): Promise<GetCrowdinProjectFilesResponse> => {
  const req = new GetCrowdinProjectFilesRequest();
  return supportServiceConnectClient.getCrowdinProjectFiles(req, { headers });
};

type DownloadTranslationToTemplateParams = {
  crowdinFileId: number;
  languageId: string;
};

export const downloadTranslationToTemplate = async (
  { crowdinFileId, languageId }: DownloadTranslationToTemplateParams,
  headers: Record<RequestMetadata, string>
): Promise<UploadCrowdinTranslationsToTemplateResponse> => {
  const req = new UploadCrowdinTranslationsToTemplateRequest({
    crowdinFileId,
    languageId,
  });
  return supportServiceConnectClient.uploadCrowdinTranslationsToTemplate(req, {
    headers,
  });
};

export const getCrowdinProjectLanguages = async (
  headers: Record<RequestMetadata, string>
): Promise<GetCrowdinProjectLanguagesResponse> => {
  const req = new GetCrowdinProjectLanguagesRequest();
  return supportServiceConnectClient.getCrowdinProjectLanguages(req, {
    headers,
  });
};

type UploadTemplateStringsToCrowdinParams = {
  templateId: string;
  folderName: string;
  languageId: string;
};

export const uploadTemplateStringsToCrowdin = async (
  { templateId, folderName, languageId }: UploadTemplateStringsToCrowdinParams,
  headers: Record<RequestMetadata, string>
): Promise<UploadTemplateStringsToCrowdinResponse> => {
  const req = new UploadTemplateStringsToCrowdinRequest({
    templateId,
    folder: folderName,
    language: languageId,
  });
  return supportServiceConnectClient.uploadTemplateStringsToCrowdin(req, {
    headers,
  });
};
